// Mapa de assuntos da tela Parâmetros de Transportadora (H1, PO1-3259): parâmetros
// do VÍNCULO embarcador × transportadora (catálogo EMBARCTRANS). Casa pelo Id.
const MAPA_TRANSPORTADORA = [
  {
    key: "fatura-impostos",
    titulo: "Fatura e impostos",
    descricao: "Vencimento, alocação de lançamentos e ISS desta transportadora.",
    blocos: [
      {
        titulo: "Fatura",
        campos: [
          { id: 13, label: "Dias para prever o vencimento", ajuda: "Quando a fatura não traz vencimento, o Hub prevê esse número de dias após a emissão." },
          { id: 14, label: "Alocação mínima do lançamento (%)", ajuda: "Percentual mínimo do lançamento que precisa casar com CT-es para a fatura ser aceita." },
        ],
      },
      {
        titulo: "ISS",
        campos: [
          { id: 15, label: "Recolhe ISS", ajuda: "Esta transportadora recolhe ISS nos fretes (afeta o valor líquido conferido)." },
          { id: 16, label: "Forma de cálculo do ISS", ajuda: "Por dentro (o imposto já está no valor e é dividido) ou por fora (é multiplicado sobre o valor)." },
        ],
      },
    ],
  },
  {
    key: "calculo-frete",
    titulo: "Cálculo de frete",
    descricao: "Como o frete esperado desta transportadora é calculado.",
    blocos: [
      {
        titulo: "Peso e agrupamento",
        campos: [
          { id: 25, label: "Peso usado no cálculo", ajuda: "Peso bruto, peso cubado ou o maior dos dois." },
          { id: 84, label: "Agrupar cálculo por nota", ajuda: "Calcula o frete nota a nota em vez de por carga." },
          { id: 169, label: "Frete combinado", ajuda: "Usa o valor combinado com a transportadora em vez da tabela." },
        ],
      },
      {
        titulo: "Veículo e serviço",
        campos: [
          { id: 88, label: "Usar veículo padrão", ajuda: "Quando o CT-e não informa o veículo, usa o veículo padrão abaixo." },
          { id: 89, label: "Veículo padrão", ajuda: "Tipo de veículo assumido no cálculo quando não vem informado." },
          { id: 150, label: "Estratégia de veículo", ajuda: "Veículo padrão fixo ou o de melhor ajuste ao peso/volume da carga." },
          { id: 155, label: "Estratégia de tipo de serviço", ajuda: "Serviço padrão ou o de melhor ajuste à composição da carga." },
        ],
      },
    ],
  },
  {
    key: "auditoria-cte",
    titulo: "Auditoria de CT-e",
    descricao: "Validações específicas dos CT-es desta transportadora.",
    blocos: [
      {
        titulo: "Validações",
        campos: [
          { id: 44, label: "Usar peso do CT-e", ajuda: "Audita o frete pelo peso declarado no CT-e em vez do peso da nota." },
          { id: 77, label: "Atualizar emitente pelo CT-e", ajuda: "O emitente do CT-e atualiza a transportadora da nota." },
          { id: 39, label: "Validar ocorrência pelo workflow", ajuda: "Ocorrências desta transportadora passam pelo fluxo de validação antes de valer." },
        ],
      },
    ],
  },
  {
    key: "envio-notas",
    titulo: "Envio de notas",
    descricao: "Envio automático das notas fiscais para a transportadora.",
    blocos: [
      {
        titulo: "Envio",
        campos: [
          { id: 29, label: "Enviar notas para a transportadora", ajuda: "Liga o envio automático das notas desta transportadora." },
          { id: 27, label: "E-mail de envio", ajuda: "Endereço da transportadora que recebe as notas." },
          { id: 28, label: "Pasta de envio", ajuda: "Pasta do SFTP onde as notas são depositadas para a transportadora." },
        ],
      },
    ],
  },
  {
    key: "cotacao",
    titulo: "Cotação",
    descricao: "Fonte de preço usada na cotação com esta transportadora.",
    blocos: [
      {
        titulo: "Fonte",
        campos: [{ id: 194, label: "Prioridade da fonte de cotação", ajuda: "Consulta primeiro a API da transportadora ou a tabela de frete cadastrada." }],
      },
    ],
  },
  {
    key: "arquivos",
    titulo: "Arquivos",
    descricao: "Romaneio e arquivos trocados com esta transportadora.",
    blocos: [
      {
        titulo: "Romaneio",
        campos: [
          { id: 74, label: "Gerar romaneio em planilha", ajuda: "Gera o romaneio (.xls) das notas desta transportadora." },
          { id: 75, label: "Pasta do romaneio", ajuda: "Pasta do SFTP onde o romaneio é gravado." },
        ],
      },
    ],
  },
  {
    // PO1-3443: parâmetros criados por script (Ids só existem depois de rodar em
    // produção), por isso casam pelo nome do catálogo.
    key: "conversor-cte-nfe",
    titulo: "Conversor CT-e → NF-e",
    descricao: "Quando a nota não chega, o Hub cria uma a partir do CT-e desta transportadora.",
    blocos: [
      {
        titulo: "Ativação",
        campos: [
          { nome: "ConverterCteParaNfeTransportadora", label: "Converter CT-e em nota para esta transportadora", ajuda: "Quando preenchido, vale mais que o parâmetro do embarcador: liga só para esta transportadora ou desliga só ela." },
        ],
      },
      {
        titulo: "Valores da nota gerada",
        descricao: "Preenchidos na nota criada a partir do CT-e. Em branco, o Hub usa os valores de sempre.",
        campos: [
          { nome: "CteParaNfeCodigoNegocio", label: "Código do negócio", ajuda: "Código do negócio do embarcador (ex.: 99) gravado na nota gerada." },
          { nome: "CteParaNfeCodigoServico", label: "Código do tipo de serviço", ajuda: "Código do tipo de serviço (ex.: 01 = Normal) gravado na nota gerada." },
          { nome: "CteParaNfeCentroCusto", label: "Centro de custo", ajuda: "Centro de custo gravado na nota gerada. É o campo que segue para o Oracle." },
          { nome: "CteParaNfeModal", label: "Modal", ajuda: "Id do modal (1 Rodoviário, 3 Marítimo) gravado na nota gerada." },
          { nome: "CteParaNfeNaturezaOperacao", label: "Natureza da operação", ajuda: "Natureza da operação (ex.: 6971) gravada na nota gerada." },
        ],
      },
    ],
  },
  {
    key: "obc",
    titulo: "Oracle",
    descricao: "Pedidos de compra e faturas enviados ao Oracle para esta transportadora.",
    blocos: [
      {
        titulo: "Envio ao Oracle",
        campos: [
          { id: 156, label: "Usuário Oracle da transportadora", ajuda: "Login da transportadora no Oracle usado ao enviar o pedido de compra." },
          { id: 93, label: "Data de corte de emissão", ajuda: "Faturas com CT-e emitido depois dessa data não são enviadas ao Oracle. Para não bloquear nenhum envio, use uma data distante (ex.: 2099-12-31)." },
        ],
      },
    ],
  },
];

export default MAPA_TRANSPORTADORA;
